import { render, staticRenderFns } from "./ggsylist.vue?vue&type=template&id=002ce9d6&scoped=true&"
import script from "./ggsylist.vue?vue&type=script&lang=js&"
export * from "./ggsylist.vue?vue&type=script&lang=js&"
import style0 from "./ggsylist.vue?vue&type=style&index=0&id=002ce9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002ce9d6",
  null
  
)

export default component.exports